/**
 * Added to doors/drawers to hold which handle type they support
 */
class AllowedHandleTypeComponent {
    constructor(handleTypes) {
        this.typeId = AllowedHandleTypeComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.handleTypes = handleTypes;
    }
    eq() {
        return false;
    }
}
AllowedHandleTypeComponent.id = 2036;
export default AllowedHandleTypeComponent;
//# sourceMappingURL=AllowedHandleTypeComponent.js.map